import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { TP } from '../../constants/consts';
import EditTranslationCard from './EditTranslationCard';
import EditMediaLayout from './EditMediaLayout';
import EditTranslationModal from './EditTranslationModal';
import FbCircularProgress from '../FbCircularProgress';
import NoListItems from '../NoListItems';

const useStyles = makeStyles({
  aboutBlock: {
    marginTop: '30px',
  },
});

export const CompanyAbout = ({ descriptions, languages, addDescription, updateDescription, deleteDescription }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [editedDescription, setEditedDescription] = React.useState(null);

  return (
    <EditMediaLayout
      className={classes.aboutBlock}
      title={`${TP}.FN_ABOUT_THE_COMPANY`}
      subtitle={`${TP}.FN_ABOUT_THE_COMPANY_SUBTITLE`}
      buttonTitle={`${TP}.FN_ADD_NEW_DESCRIPTION`}
      addButtonClick={() => setEditedDescription({ content: '' })}
    >
      {Boolean(descriptions.data?.length) &&
        descriptions.data.map(d => (
          <EditTranslationCard
            key={`description_${d.id}`}
            translation={d}
            editTranslationClick={() => setEditedDescription({ ...d, content: d.description })}
            editButtonLabel={`${TP}.FN_EDIT`}
            deleteFunc={deleteDescription}
          />
        ))}
      {descriptions.loading && <FbCircularProgress />}
      {!descriptions.loading && Boolean(!descriptions.data?.length) && (
        <NoListItems text={t(`${TP}.FN_NO_DESCRIPTIONS_ADDED`)} />
      )}
      {Boolean(editedDescription) && (
        <EditTranslationModal
          variant={editedDescription.language ? 'edit' : 'add'}
          isModalOpen
          bio={editedDescription}
          addFunc={data => {
            addDescription(data, () => setEditedDescription(null));
          }}
          updateBio={data => {
            updateDescription(data, () => setEditedDescription(null));
          }}
          onClose={() => setEditedDescription(null)}
          modalTitle={{ add: `${TP}.FN_ADD_DESCRIPTION`, edit: `${TP}.FN_EDIT_DESCRIPTION` }}
          textAreaLabel={`${TP}.FN_ENTER_DESCRIPTION_TEXT`}
          langs={languages}
          loading={descriptions.isDescriptionUpdating}
        />
      )}
    </EditMediaLayout>
  );
};

CompanyAbout.propTypes = {
  descriptions: PropTypes.object,
  languages: PropTypes.array,
  addDescription: PropTypes.func.isRequired,
  updateDescription: PropTypes.func.isRequired,
  deleteDescription: PropTypes.func.isRequired,
};

CompanyAbout.defaultProps = {
  descriptions: {},
  languages: [],
};

export default memo(CompanyAbout);
